/**
 * English -> Arabic country name lookup.
 * Participant/user records store the country as a plain English name (not an ISO code),
 * so this is a direct string map rather than a code-based lookup. Matching is
 * case-insensitive and whitespace-trimmed; unmapped names fall back to the original text.
 */
const COUNTRY_NAME_AR: Record<string, string> = {
  'afghanistan': 'أفغانستان',
  'aland islands': 'جزر أولاند',
  'albania': 'ألبانيا',
  'algeria': 'الجزائر',
  'american samoa': 'ساموا الأمريكية',
  'andorra': 'أندورا',
  'angola': 'أنغولا',
  'anguilla': 'أنغويلا',
  'antarctica': 'أنتاركتيكا',
  'antigua and barbuda': 'أنتيغوا وباربودا',
  'argentina': 'الأرجنتين',
  'armenia': 'أرمينيا',
  'aruba': 'أروبا',
  'australia': 'أستراليا',
  'austria': 'النمسا',
  'azerbaijan': 'أذربيجان',
  'bahamas': 'باهاماس',
  'bahrain': 'البحرين',
  'bangladesh': 'بنغلاديش',
  'barbados': 'باربادوس',
  'belarus': 'بيلاروسيا',
  'belgium': 'بلجيكا',
  'belize': 'بليز',
  'benin': 'بنين',
  'bermuda': 'برمودا',
  'bhutan': 'بوتان',
  'bolivia': 'بوليفيا',
  'bosnia and herzegovina': 'البوسنة والهرسك',
  'botswana': 'بوتسوانا',
  'bouvet island': 'جزيرة بوفيه',
  'brazil': 'البرازيل',
  'british indian ocean territory': 'إقليم المحيط الهندي البريطاني',
  'brunei': 'بروناي',
  'brunei darussalam': 'بروناي',
  'bulgaria': 'بلغاريا',
  'burkina faso': 'بوركينا فاسو',
  'burundi': 'بوروندي',
  'cabo verde': 'الرأس الأخضر',
  'cape verde': 'الرأس الأخضر',
  'cambodia': 'كمبوديا',
  'cameroon': 'الكاميرون',
  'canada': 'كندا',
  'cayman islands': 'جزر كايمان',
  'central african republic': 'جمهورية أفريقيا الوسطى',
  'chad': 'تشاد',
  'chile': 'تشيلي',
  'china': 'الصين',
  'christmas island': 'جزيرة كريسماس',
  'cocos (keeling) islands': 'جزر كوكوس',
  'colombia': 'كولومبيا',
  'comoros': 'جزر القمر',
  'congo': 'الكونغو',
  'congo, democratic republic of the': 'جمهورية الكونغو الديمقراطية',
  'cook islands': 'جزر كوك',
  'costa rica': 'كوستاريكا',
  'croatia': 'كرواتيا',
  'cuba': 'كوبا',
  'curacao': 'كوراساو',
  'curaçao': 'كوراساو',
  'cyprus': 'قبرص',
  'czech republic': 'التشيك',
  'czechia': 'التشيك',
  'denmark': 'الدنمارك',
  'djibouti': 'جيبوتي',
  'dominica': 'دومينيكا',
  'dominican republic': 'جمهورية الدومينيكان',
  'dr congo': 'جمهورية الكونغو الديمقراطية',
  'democratic republic of the congo': 'جمهورية الكونغو الديمقراطية',
  'ecuador': 'الإكوادور',
  'egypt': 'مصر',
  'el salvador': 'السلفادور',
  'equatorial guinea': 'غينيا الاستوائية',
  'eritrea': 'إريتريا',
  'estonia': 'إستونيا',
  'eswatini': 'إسواتيني',
  'ethiopia': 'إثيوبيا',
  'falkland islands (malvinas)': 'جزر فوكلاند',
  'falkland islands': 'جزر فوكلاند',
  'faroe islands': 'جزر فارو',
  'fiji': 'فيجي',
  'finland': 'فنلندا',
  'france': 'فرنسا',
  'french guiana': 'غويانا الفرنسية',
  'french polynesia': 'بولينيزيا الفرنسية',
  'french southern territories': 'الأقاليم الجنوبية الفرنسية',
  'gabon': 'الغابون',
  'gambia': 'غامبيا',
  'georgia': 'جورجيا',
  'germany': 'ألمانيا',
  'ghana': 'غانا',
  'gibraltar': 'جبل طارق',
  'greece': 'اليونان',
  'greenland': 'جرينلاند',
  'grenada': 'غرينادا',
  'guadeloupe': 'غوادلوب',
  'guam': 'غوام',
  'guatemala': 'غواتيمالا',
  'guernsey': 'غيرنزي',
  'guinea': 'غينيا',
  'guinea-bissau': 'غينيا بيساو',
  'guyana': 'غويانا',
  'haiti': 'هايتي',
  'heard island and mcdonald islands': 'جزيرة هيرد وجزر ماكدونالد',
  'holy see (vatican city state)': 'الفاتيكان',
  'holy see': 'الفاتيكان',
  'honduras': 'هندوراس',
  'hong kong': 'هونغ كونغ',
  'hungary': 'المجر',
  'iceland': 'آيسلندا',
  'india': 'الهند',
  'indonesia': 'إندونيسيا',
  'iran': 'إيران',
  'iran, islamic republic of': 'إيران',
  'iraq': 'العراق',
  'ireland': 'أيرلندا',
  'isle of man': 'جزيرة مان',
  'israel': 'إسرائيل',
  'italy': 'إيطاليا',
  'ivory coast': 'ساحل العاج',
  "cote d'ivoire": 'ساحل العاج',
  'jamaica': 'جامايكا',
  'japan': 'اليابان',
  'jersey': 'جيرزي',
  'jordan': 'الأردن',
  'kazakhstan': 'كازاخستان',
  'kenya': 'كينيا',
  'kiribati': 'كيريباتي',
  'korea, democratic people\'s republic of': 'كوريا الشمالية',
  'korea, republic of': 'كوريا الجنوبية',
  'kosovo': 'كوسوفو',
  'kuwait': 'الكويت',
  'kyrgyzstan': 'قيرغيزستان',
  'laos': 'لاوس',
  'lao people\'s democratic republic': 'لاوس',
  'latvia': 'لاتفيا',
  'lebanon': 'لبنان',
  'lesotho': 'ليسوتو',
  'liberia': 'ليبيريا',
  'libya': 'ليبيا',
  'libyan arab jamahiriya': 'ليبيا',
  'liechtenstein': 'ليختنشتاين',
  'lithuania': 'ليتوانيا',
  'luxembourg': 'لوكسمبورغ',
  'macao': 'ماكاو',
  'macau': 'ماكاو',
  'macedonia, the former yugoslav republic of': 'مقدونيا الشمالية',
  'madagascar': 'مدغشقر',
  'malawi': 'مالاوي',
  'malaysia': 'ماليزيا',
  'maldives': 'المالديف',
  'mali': 'مالي',
  'malta': 'مالطا',
  'marshall islands': 'جزر مارشال',
  'martinique': 'مارتينيك',
  'mauritania': 'موريتانيا',
  'mauritius': 'موريشيوس',
  'mayotte': 'مايوت',
  'mexico': 'المكسيك',
  'micronesia': 'ميكرونيزيا',
  'micronesia, federated states of': 'ميكرونيزيا',
  'moldova': 'مولدوفا',
  'moldova, republic of': 'مولدوفا',
  'monaco': 'موناكو',
  'mongolia': 'منغوليا',
  'montenegro': 'الجبل الأسود',
  'montserrat': 'مونتسرات',
  'morocco': 'المغرب',
  'mozambique': 'موزمبيق',
  'myanmar': 'ميانمار',
  'namibia': 'ناميبيا',
  'nauru': 'ناورو',
  'nepal': 'نيبال',
  'netherlands': 'هولندا',
  'netherlands antilles': 'جزر الأنتيل الهولندية',
  'new caledonia': 'كاليدونيا الجديدة',
  'new zealand': 'نيوزيلندا',
  'nicaragua': 'نيكاراغوا',
  'niger': 'النيجر',
  'nigeria': 'نيجيريا',
  'niue': 'نييوي',
  'norfolk island': 'جزيرة نورفولك',
  'north korea': 'كوريا الشمالية',
  'north macedonia': 'مقدونيا الشمالية',
  'northern mariana islands': 'جزر ماريانا الشمالية',
  'norway': 'النرويج',
  'oman': 'عُمان',
  'pakistan': 'باكستان',
  'palau': 'بالاو',
  'palestine': 'فلسطين',
  'palestinian territory, occupied': 'فلسطين',
  'panama': 'بنما',
  'papua new guinea': 'بابوا غينيا الجديدة',
  'paraguay': 'باراغواي',
  'peru': 'بيرو',
  'philippines': 'الفلبين',
  'pitcairn': 'جزر بيتكيرن',
  'poland': 'بولندا',
  'portugal': 'البرتغال',
  'puerto rico': 'بورتوريكو',
  'qatar': 'قطر',
  'reunion': 'ريونيون',
  'romania': 'رومانيا',
  'russia': 'روسيا',
  'russian federation': 'روسيا',
  'rwanda': 'رواندا',
  'saint barthelemy': 'سان بارتيلمي',
  'saint helena': 'سانت هيلانة',
  'saint kitts and nevis': 'سانت كيتس ونيفيس',
  'saint lucia': 'سانت لوسيا',
  'saint martin': 'سان مارتن',
  'saint pierre and miquelon': 'سان بيير وميكلون',
  'saint vincent and the grenadines': 'سانت فينسنت والغرينادين',
  'samoa': 'ساموا',
  'san marino': 'سان مارينو',
  'sao tome and principe': 'ساو تومي وبرينسيبي',
  'saudi arabia': 'المملكة العربية السعودية',
  'senegal': 'السنغال',
  'serbia': 'صربيا',
  'seychelles': 'سيشل',
  'sierra leone': 'سيراليون',
  'singapore': 'سنغافورة',
  'sint maarten': 'سينت مارتن',
  'slovakia': 'سلوفاكيا',
  'slovenia': 'سلوفينيا',
  'solomon islands': 'جزر سليمان',
  'somalia': 'الصومال',
  'south africa': 'جنوب أفريقيا',
  'south georgia and the south sandwich islands': 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
  'south korea': 'كوريا الجنوبية',
  'south sudan': 'جنوب السودان',
  'spain': 'إسبانيا',
  'sri lanka': 'سريلانكا',
  'sudan': 'السودان',
  'suriname': 'سورينام',
  'svalbard and jan mayen': 'سفالبارد وجان ماين',
  'swaziland': 'إسواتيني',
  'sweden': 'السويد',
  'switzerland': 'سويسرا',
  'syria': 'سوريا',
  'syrian arab republic': 'سوريا',
  'taiwan': 'تايوان',
  'tajikistan': 'طاجيكستان',
  'tanzania': 'تنزانيا',
  'tanzania, united republic of': 'تنزانيا',
  'thailand': 'تايلاند',
  'timor-leste': 'تيمور الشرقية',
  'togo': 'توغو',
  'tokelau': 'توكيلاو',
  'tonga': 'تونغا',
  'trinidad and tobago': 'ترينيداد وتوباغو',
  'tunisia': 'تونس',
  'turkey': 'تركيا',
  'turkmenistan': 'تركمانستان',
  'turks and caicos islands': 'جزر توركس وكايكوس',
  'tuvalu': 'توفالو',
  'uganda': 'أوغندا',
  'ukraine': 'أوكرانيا',
  'united arab emirates': 'الإمارات العربية المتحدة',
  'united kingdom': 'المملكة المتحدة',
  'united states': 'الولايات المتحدة',
  'united states of america': 'الولايات المتحدة',
  'united states minor outlying islands': 'جزر الولايات المتحدة الصغيرة النائية',
  'uruguay': 'الأوروغواي',
  'uzbekistan': 'أوزبكستان',
  'vanuatu': 'فانواتو',
  'vatican city': 'الفاتيكان',
  'venezuela': 'فنزويلا',
  'venezuela, bolivarian republic of': 'فنزويلا',
  'vietnam': 'فيتنام',
  'viet nam': 'فيتنام',
  'virgin islands, british': 'الجزر العذراء البريطانية',
  'virgin islands, u.s.': 'الجزر العذراء الأمريكية',
  'wallis and futuna': 'واليس وفوتونا',
  'western sahara': 'الصحراء الغربية',
  'yemen': 'اليمن',
  'zambia': 'زامبيا',
  'zimbabwe': 'زيمبابوي',
};

export function translateCountryName(name: string, forceArabic: boolean = false): string {
  if (!name) return name;
  const isAr = forceArabic || localStorage.getItem('lang') === 'ar';
  if (!isAr) return name;

  let clean = name.trim();
  if (clean.toLowerCase() === 'all') return 'جميع الدول';

  // Normalize camelCase like "AmericanSamoa" -> "American Samoa"
  const spaced = clean.replace(/([a-z])([A-Z])/g, '$1 $2').trim();
  // Strip any leading numbers like "1058911 Aland Islands"
  const stripped = spaced.replace(/^\d+\s+/, '').trim();

  const key1 = clean.toLowerCase();
  const key2 = spaced.toLowerCase();
  const key3 = stripped.toLowerCase();
  const key4 = key1.replace(/[\s\-_]+/g, '');

  return COUNTRY_NAME_AR[key1] ||
         COUNTRY_NAME_AR[key2] ||
         COUNTRY_NAME_AR[key3] ||
         COUNTRY_NAME_AR[key4] ||
         clean;
}
